import { render, staticRenderFns } from "./business-list.vue?vue&type=template&id=29bc260e&"
import script from "./business-list.vue?vue&type=script&lang=js&"
export * from "./business-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports